import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Component, Watch } from 'vue-property-decorator';

@Component({
    props: ['defaultValue'],
    template: require('./comment-editor.html'),
})
export class CommentEditor extends ReactiveVue {
    public defaultValue: string;
    public value: string = '';

    public value$ = new Subject<string>();
    public change$ = this.value$.pipe(
        distinctUntilChanged(),
        debounceTime(300),
    );

    public mounted() {
        this.subscribeTo(this.change$, value => {
            this.$emit('change', value);
        });
    }

    @Watch('defaultValue', { immediate: true })
    private onDefaultValueChange(defaultValue: string) {
        this.value = defaultValue;
    }

    @Watch('value')
    private onValueChange(value: string) {
        this.value$.next(value);
    }
}
